import { CardSelectButton } from '../CardSelectButton';
import { DiscountPriceDisplay } from '../PriceDisplay';
import { TextButton } from '../TextButton';
import {
  BottomRow,
  CardWrapper,
  ContentColumn,
  DetailsButton,
  Name,
  PriceBlock,
  PromotionPill,
  SecondaryPrice,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  TitleRow,
  UnavailableText,
} from './AccommodationItemCard.styles';
import type { AccommodationItemCardProps } from './AccommodationItemCard.types';

export function AccommodationItemCard({
  name,
  image,
  showImage = true,
  price,
  discount,
  secondaryPriceLabel,
  detailsLabel = 'More details',
  onSelect,
  selected,
  onCardClick,
  promotionName,
  locale,
  unavailable,
  unavailableLabel = 'Unavailable',
  editSearchLabel = 'Edit search',
  onEditSearch,
}: AccommodationItemCardProps) {
  const clickable = !unavailable && !!onCardClick;

  return (
    <CardWrapper
      $unavailable={unavailable}
      $selected={selected}
      $clickable={clickable}
      data-testid="accommodation-item-card"
      onClick={clickable ? onCardClick : undefined}
    >
      {showImage && (
        <Thumbnail>
          {image?.src ? (
            <ThumbnailImage src={image.src} alt={image.alt ?? ''} />
          ) : (
            <ThumbnailPlaceholder data-testid="thumbnail-placeholder" />
          )}
        </Thumbnail>
      )}
      <ContentColumn>
        <TitleRow>
          <Name>
            {clickable && onCardClick ? (
              <CardSelectButton aria-pressed={selected} onSelect={onCardClick}>
                {name}
              </CardSelectButton>
            ) : (
              name
            )}
          </Name>
          {!unavailable && price && (
            <PriceBlock>
              <DiscountPriceDisplay price={price} discount={discount} locale={locale} size="base" />
              {secondaryPriceLabel && <SecondaryPrice>{secondaryPriceLabel}</SecondaryPrice>}
            </PriceBlock>
          )}
        </TitleRow>
        <BottomRow>
          {unavailable ? (
            <>
              <UnavailableText>{unavailableLabel}</UnavailableText>
              {onEditSearch && (
                <TextButton size="xs" onClick={onEditSearch}>
                  {editSearchLabel}
                </TextButton>
              )}
            </>
          ) : (
            <>
              {detailsLabel && (
                <DetailsButton
                  type="button"
                  aria-label={`${detailsLabel}, ${name}`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onSelect?.();
                  }}
                >
                  {detailsLabel}
                </DetailsButton>
              )}
              {promotionName && <PromotionPill>{promotionName}</PromotionPill>}
            </>
          )}
        </BottomRow>
      </ContentColumn>
    </CardWrapper>
  );
}
